<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import BlockContent from '../UI/Content/BlockContent.vue'

export default {
  components: { BlockContent },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    rent: { type: Object, default: null },
    profitability: { type: Object, default: null },
  },

  computed: {
    profitabilityClass() {
      const value =
        this.profitability.totalPercentCession !== null ? this.profitability.totalPercentCession : this.rent.margin
      return value < 0 ? 'text-danger' : 'text-success'
    },
  },
}
</script>
<template>
  <div v-if="hasRole('ROLE_RENT_EDIT') && rent != null" class="row">
    <div class="col-12">
      <BlockContent :title="$t('simulation.result.profitability')" e2e-block="simulationProfitability">
        <div class="row mt-2">
          <div class="col"><i class="fa fa-money-bill mr-1"></i>{{ $t('demand.list.amountCession') }}</div>
          <div class="col" e2e-data="simulationProfitabilityTransferAmount">
            {{
              profitability.transferAmount
                ? $n(Number(profitability.transferAmount), 'currency')
                : $n(Number(rent.amount), 'currency')
            }}
          </div>
        </div>
        <div v-if="conf.theme_dir != 'yneia'" :class="'row my-2 ' + profitabilityClass">
          <div class="col"><i class="fa fa-piggy-bank mr-1"></i>{{ $t('demand.fields.profitability.label') }}</div>
          <div class="col" e2e-data="simulationProfitabilityTotalPercentCession">
            {{
              profitability.totalPercentCession
                ? $n(Number(profitability.totalPercentCession), 'decimal')
                : $n(Number(rent.margin), 'decimal')
            }}
            %
          </div>
        </div>
        <div v-if="conf.theme_dir != 'yneia'" class="row mt-2">
          <div class="col"></div>
          <div class="col" e2e-data="simulationProfitabilityRent">
            {{
              profitability.profitability
                ? $n(Number(profitability.profitability), 'currency')
                : $n(Number(rent.profitability), 'currency')
            }}
            {{ $t('main.dutyFree') }}
          </div>
        </div>
        <div v-if="profitability.servicesPercentProfitability" class="row mt-2">
          <div class="col">
            <i class="fa fa-chart-pie mr-1"></i>{{ $t('profitability.servicesPercentProfitability') }}
          </div>
          <div class="col" e2e-data="simulationProfitabilityServicesPercent">
            {{ $n(Number(profitability.servicesPercentProfitability), 'decimal') }} %
          </div>
        </div>
        <div v-if="rent.clientRate && conf.theme_dir != 'yneia'" class="row mt-2">
          <div class="col"><i class="far fa-user"></i> {{ $t('demand.fields.finance.clientRate.label') }}</div>
          <div class="col" e2e-data="simulationProfitabilityClientRate">
            {{ $n(Number(rent.clientRate), 'decimal') }} %
          </div>
        </div>
        <div v-if="rent.soldRate && conf.theme_dir != 'yneia'" class="row mt-2">
          <div class="col"><i class="fas fa-percentage"></i> {{ $t('demand.fields.finance.soldRate.label') }}</div>
          <div class="col" e2e-data="simulationProfitabilitySoldRate">{{ $n(Number(rent.soldRate), 'decimal') }} %</div>
        </div>
      </BlockContent>
    </div>
  </div>
</template>
